import { useMount } from 'react-use'
import { useLazyQuery, useQuery } from '@apollo/client'
import { fetchPolicy } from 'lib/apolloFetchPolicy'

const defaultOptions = {
    variables: {},
    pollInterval: 10000,
    stopOnError: true,
}

/**
 * Could not achieve this with useQuery or useLazyQuery, so used both.
 * Simply save one query call by trying to read cache on initial call.
 * Then continue with polling network.
 */
const useQueryCachedThenPollNetwork = (query, options) => {
    options = {
        ...defaultOptions,
        ...options,
    }

    const initQueryObject = useQuery(query, { variables: options.variables, fetchPolicy: fetchPolicy.CACHE_FIRST })
    const pollQueryObject = useLazyQuery(query, {
        variables: {},
        fetchPolicy: fetchPolicy.NETWORK_ONLY,
        pollInterval: options.pollInterval,
    })

    const [pollQuery, { error, stopPolling, called, loading }] = pollQueryObject

    const object = called && !loading
        ? pollQueryObject[1]
        : initQueryObject

    if (options.stopOnError && error) stopPolling()

    useMount(() => {
        const timeout = setTimeout(() => {
            if (options.stopOnError && error) return
            pollQuery({ variables: options.variables })
        }, options.pollInterval)
        return () => clearTimeout(timeout)
    })

    return { ...object }
}

export default useQueryCachedThenPollNetwork
